// extracted by mini-css-extract-plugin
export default {"input":"AddCategory_input__C+FCt"};